import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { DispatchProps, OwnProps, StateProps } from './CaseSessionTab';
import CaseSession from './CaseSessionTab';
import { StoreState } from 'src/store/reducers';
import { getCase, getStatementsDocs } from 'src/store/actions/case-actions';

import { QueryParams } from 'src/types/grid';

import { getCases } from '../../../../../../../../../store/actions/case-actions';
import { getSeance, getSeances, getSeancesStatistics } from '../../../../../../../../../store/actions/seance-actions';
import { getInvoices } from '../../../../../../../../../store/actions/invoice-actions';
import { getServiceTypes } from '../../../../../../../../../store/actions/service-type-actions';
import { getServiceLocations } from '../../../../../../../../../store/actions/service-location-actions';

function mapStateToProps(state: StoreState, ownProps: OwnProps): StateProps {
    return {
        cases: state.cases.data,
        providerEntity: state.auth.data,
        caseData: state.cases.current,
        inProgress: state.cases.inProgress,
        current: state.seances.current,
        invoices: state.invoices.data,
        inProgressAll: state.cases.inProgressAll,
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps): DispatchProps {
    return {
        getCases: (params: QueryParams) => dispatch(getCases(params)),
        getStatistics: (params: any) => dispatch(getSeancesStatistics(params)),
        getDataSeance: (params: QueryParams) => dispatch(getSeances(params)),
        getData: (id) => dispatch(getSeance(id)),
        getInvoices: (params: QueryParams) => dispatch(getInvoices(params)),
        getStatementsDocs: (params: QueryParams) => dispatch(getStatementsDocs(params)),
        getServiceTypes: (params: QueryParams) => dispatch(getServiceTypes(params)),
        getServiceLocations: (params: QueryParams) => dispatch(getServiceLocations(params)),
        getCase: (id) => dispatch(getCase(id)),
    };
}

const CaseSessionTab = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(CaseSession);

export default CaseSessionTab;
